import { CardType } from 'types/deck'

/**
 *
 * Modify search results to include counts for other printings of the same card
 *
 * eg: In card search we show the little blue circle for other printings of the same card
 *
 * @param deck
 * @param results
 * @returns
 */
export const modifySearchResults = (deck: CardType[], results: CardType[]): CardType[] => {
  return results.map(card => {
    if (!card) return card

    let hasFoundPrinting = false

    // prettier-ignore
    const matchingCardInDeck = deck.find(deckCard => card.oracleCardUid === deckCard.oracleCardUid)

    if (matchingCardInDeck) return matchingCardInDeck

    // Card not in deck
    return { ...card, categories: [], qty: 0 }
  })
}
